import './BundleInstructionsPage.scss';

import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonChip,
  IonCol,
  IonContent,
  IonGrid,
  IonImg,
  IonItem,
  IonLabel,
  IonPage,
  IonRow,
} from '@ionic/react';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { GenericMessages } from 'src/intl/GenericMessages';
import EnableMacrosImg from '../../assets/images/bundle-instructions/img-enable-macros.png';
import InstallBundleImg from '../../assets/images/bundle-instructions/img-install-bundle.png';
import MirrorTubeImg from '../../assets/images/bundle-instructions/img-mirror-tube-map.png';
import SaveAsImg from '../../assets/images/bundle-instructions/img-save-as.png';
import Section3Subsection3Img from '../../assets/images/bundle-instructions/img-section3-subsection3.jpg';
import Section3Subsection4Img1 from '../../assets/images/bundle-instructions/img-section3-subsection4-img1.jpg';
import Section3Subsection4Img2 from '../../assets/images/bundle-instructions/img-section3-subsection4-img2.jpg';
import Section4SquarePatternImg from '../../assets/images/bundle-instructions/img-section4-square-pattern.jpg';
import Section4TrianglePatternImg from '../../assets/images/bundle-instructions/img-section4-triangle-pattern.jpg';
import TubeNamesImg from '../../assets/images/bundle-instructions/img-tube-names.png';
import { BundleTemplateDownloadButton } from '../../components/bundles/BundleTemplateDownloadButton';
import { DqText } from '../../components/dq-text';
import { BundleMessages } from '../../intl/BundleMessages';
import DesktopDetailPageHeader from 'src/components/reusable-components/desktop-header/DesktopDetailPageHeader';
import { englishOnlyIntl, useGA4 } from '../../utils/ga4';

export const BundleInstructionsPage: FC = () => {
  document.title = englishOnlyIntl.formatMessage(BundleMessages.bundleInstructionsTitle);
  useGA4();

  const { formatMessage, locale } = useIntl();

  return (
    <IonPage>
      <DesktopDetailPageHeader
        left
        heading={formatMessage(BundleMessages.bundleInstructionsTitle)}
        subheading={formatMessage(BundleMessages.bundleInstructionsSubtitle)}
      />
      <IonContent>
        <IonGrid className="bundle-instructions-grid">
          <IonRow>
            {/* Instructions Section 1 */}
            <IonCol size="6">
              <IonCard>
                <IonCardHeader>
                  <IonRow className="ion-justify-content-between">
                    <BundleInstructionsHeader
                      title={formatMessage(BundleMessages.bundleInstructionsSection1Title)}
                      sectionNumber={'1'}
                    />
                    <div>
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection1Line1)}</DqText>
                      <br />
                      <br />
                    </div>
                    <div>
                      <BundleTemplateDownloadButton />
                    </div>
                  </IonRow>
                </IonCardHeader>
              </IonCard>
            </IonCol>
            {/* Instructions Section 2 */}
            <IonCol size="6">
              <IonCard>
                <IonCardHeader>
                  <BundleInstructionsHeader
                    title={formatMessage(BundleMessages.bundleInstructionsSection2Title)}
                    sectionNumber={'2'}
                  />
                </IonCardHeader>
                <IonCardContent>
                  <IonRow>
                    <IonCol size="6">
                      <ul>
                        <li>
                          <DqText variant="body">
                            {formatMessage(BundleMessages.bundleInstructionsSection2Line1)}
                          </DqText>
                        </li>
                        <li>
                          <DqText variant="body">
                            {formatMessage(BundleMessages.bundleInstructionsSection2Line2)}
                          </DqText>
                        </li>
                        <li>
                          <DqText variant="body">
                            {formatMessage(BundleMessages.bundleInstructionsSection2Line3)}
                          </DqText>
                        </li>
                        <li>
                          <DqText variant="body">
                            {formatMessage(BundleMessages.bundleInstructionsSection2Line4)}
                          </DqText>
                        </li>
                      </ul>
                    </IonCol>
                    <IonCol>
                      <IonImg src={EnableMacrosImg} />
                    </IonCol>
                  </IonRow>
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>

          <IonRow>
            {/* Instructions Section 3 */}
            <IonCol size="6">
              <IonCard>
                <IonCardHeader>
                  <BundleInstructionsHeader
                    title={formatMessage(BundleMessages.bundleInstructionsSection3Title)}
                    sectionNumber={'3'}
                  />
                </IonCardHeader>
                <IonCardContent>
                  <DqText variant="body-strong">
                    {formatMessage(BundleMessages.bundleInstructionsSection3Subtitle1)}
                  </DqText>
                  <br />
                  <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection3Line1)}</DqText>
                  <ul>
                    <li>
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection3Line2)}</DqText>
                    </li>
                    <li>
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection3Line3)}</DqText>
                    </li>
                    <li>
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection3Line4)}</DqText>
                    </li>
                    <li>
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection3Line5)}</DqText>
                    </li>
                    <li>
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection3Line6)}</DqText>
                    </li>
                  </ul>

                  <DqText variant="body-strong">
                    {formatMessage(BundleMessages.bundleInstructionsSection3Subtitle2)}
                  </DqText>
                  <br />
                  <DqText variant="body">
                    {formatMessage(BundleMessages.bundleInstructionsSection3Subsection2Line1)}
                  </DqText>
                  <br />
                  <br />

                  <DqText variant="body-strong">
                    {formatMessage(BundleMessages.bundleInstructionsSection3Subtitle3)}
                  </DqText>
                  <br />
                  <DqText variant="body">
                    {formatMessage(BundleMessages.bundleInstructionsSection3Subsection3Line1)}
                  </DqText>
                  <br />
                  <br />
                  <IonImg src={Section3Subsection3Img} />
                </IonCardContent>
              </IonCard>
            </IonCol>
            <IonCol size="6">
              <IonCard>
                <IonCardHeader>
                  <BundleInstructionsHeader title={formatMessage(BundleMessages.bundleInstructionsSection3Subtitle4)} />
                </IonCardHeader>
                <IonCardContent>
                  <IonImg src={Section3Subsection4Img1} />
                  <DqText variant="body">
                    {formatMessage(BundleMessages.bundleInstructionsSection3Subsection4Caption1)}
                  </DqText>
                  <br />
                  <br />
                  <IonImg src={Section3Subsection4Img2} />
                  <DqText variant="body">
                    {formatMessage(BundleMessages.bundleInstructionsSection3Subsection4Caption2)}
                  </DqText>
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>

          <IonRow>
            {/* Instructions Section 4 */}
            <IonCol size="6">
              <IonCard>
                <IonCardHeader>
                  <BundleInstructionsHeader
                    title={formatMessage(BundleMessages.bundleInstructionsSection4Title)}
                    sectionNumber={'4'}
                  />
                </IonCardHeader>
                <IonCardContent>
                  <IonRow>
                    <IonCol size="6">
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection4Line1)}</DqText>
                      <br />
                      <br />

                      <DqText variant="body-strong">
                        {formatMessage(BundleMessages.bundleInstructionsSection4Subsection1Title)}
                      </DqText>
                      <br />
                      <DqText variant="body">
                        {formatMessage(BundleMessages.bundleInstructionsSection4Subsection1Line1)}
                      </DqText>
                      <br />
                      <br />
                      <DqText variant="body-strong">
                        {formatMessage(BundleMessages.bundleInstructionsSection4Subsection2Title)}
                      </DqText>
                      <br />
                      <DqText variant="body">
                        {formatMessage(BundleMessages.bundleInstructionsSection4Subsection2Line1)}
                      </DqText>
                      <br />
                      <br />
                      <DqText variant="body-strong">
                        {formatMessage(BundleMessages.bundleInstructionsSection4Subsection3Title)}
                      </DqText>
                      <br />
                      <DqText variant="body">
                        {formatMessage(BundleMessages.bundleInstructionsSection4Subsection3Line1)}
                      </DqText>
                      <br />
                      <br />
                      <DqText variant="body-strong">
                        {formatMessage(BundleMessages.bundleInstructionsSection4Subsection4Title)}
                      </DqText>
                      <br />
                      <DqText variant="body">
                        {formatMessage(BundleMessages.bundleInstructionsSection4Subsection4Line1)}
                      </DqText>
                      <ul>
                        <li>
                          <DqText variant="body">
                            {formatMessage(BundleMessages.bundleInstructionsSection4Subsection4Line2)}
                          </DqText>
                        </li>
                        <li>
                          <DqText variant="body">
                            {formatMessage(BundleMessages.bundleInstructionsSection4Subsection4Line3)}
                          </DqText>
                        </li>
                      </ul>
                    </IonCol>
                    <IonCol size="6">
                      <IonRow>
                        <IonImg src={Section4SquarePatternImg} />
                      </IonRow>
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection4Caption1)}</DqText>
                      <br />
                      <br />
                      <IonRow>
                        <IonImg src={Section4TrianglePatternImg} />
                      </IonRow>
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection4Caption2)}</DqText>
                      <br />
                      <br />
                      <IonRow>
                        <IonImg src={TubeNamesImg} />
                      </IonRow>
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection4Caption3)}</DqText>
                      <br />
                      <br />
                      <IonRow>
                        <IonImg src={MirrorTubeImg} />
                      </IonRow>
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection4Caption4)}</DqText>
                    </IonCol>
                  </IonRow>
                </IonCardContent>
              </IonCard>
            </IonCol>
            {/* Instructions Section 5 */}
            <IonCol size="6">
              <IonCard>
                <IonCardHeader>
                  <BundleInstructionsHeader
                    title={formatMessage(BundleMessages.bundleInstructionsSection5Title)}
                    sectionNumber={'5'}
                  />
                </IonCardHeader>
                <IonCardContent>
                  <IonRow>
                    <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection5Line1)}</DqText>
                  </IonRow>
                  <br />
                  <IonRow>
                    <IonImg src={SaveAsImg} />
                  </IonRow>
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>

          <IonRow>
            {/* Instructions Section 6 */}
            <IonCol size="6">
              <IonCard>
                <IonCardHeader>
                  <BundleInstructionsHeader
                    title={formatMessage(BundleMessages.bundleInstructionsSection6Title)}
                    sectionNumber={'6'}
                  />
                </IonCardHeader>
                <IonCardContent>
                  <IonRow>
                    <IonCol size="12">
                      <DqText variant="body-strong">
                        {formatMessage(BundleMessages.bundleInstructionsSection6Subsection1Title)}
                      </DqText>
                      <br />
                      <DqText variant="body">
                        {formatMessage(BundleMessages.bundleInstructionsSection6Subsection1Line1)}
                      </DqText>
                      <br />
                      <br />

                      <DqText variant="body-strong">
                        {formatMessage(BundleMessages.bundleInstructionsSection6Subsection2Title)}
                      </DqText>
                      <br />
                      <DqText variant="body">
                        {formatMessage(BundleMessages.bundleInstructionsSection6Subsection2Line1)}
                      </DqText>
                      <ul>
                        <li>
                          <DqText variant="body">
                            {formatMessage(BundleMessages.bundleInstructionsSection6Subsection2Line2)}
                          </DqText>
                        </li>
                        <li>
                          <DqText variant="body">
                            {formatMessage(BundleMessages.bundleInstructionsSection6Subsection2Line3)}
                          </DqText>
                        </li>
                        <li>
                          <DqText variant="body">
                            {formatMessage(BundleMessages.bundleInstructionsSection6Subsection2Line4)}
                          </DqText>
                        </li>
                      </ul>

                      <DqText variant="body-strong">
                        {formatMessage(BundleMessages.bundleInstructionsSection6Subsection3Title)}
                      </DqText>
                      <br />
                      <DqText variant="body">
                        {formatMessage(BundleMessages.bundleInstructionsSection6Subsection3Line1)}
                      </DqText>
                    </IonCol>
                  </IonRow>
                </IonCardContent>
              </IonCard>
            </IonCol>
            {/* Instructions Section 7 */}
            <IonCol size="6">
              <IonCard>
                <IonCardHeader>
                  <BundleInstructionsHeader
                    title={formatMessage(BundleMessages.bundleInstructionsSection7Title)}
                    sectionNumber={'7'}
                  />
                </IonCardHeader>
                <IonCardContent>
                  <IonRow>
                    <IonCol size="6">
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection7Line1)}</DqText>
                      <br />
                      <br />
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection7Line2)}</DqText>
                      <br />
                      <br />
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSection7Line3)}</DqText>
                    </IonCol>
                    <IonCol size="6">
                      <IonImg src={InstallBundleImg} />
                    </IonCol>
                  </IonRow>
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>

          <IonRow>
            <IonCol size="12">
              <IonCard>
                <IonCardContent>
                  <IonRow>
                    <IonCol size="12">
                      <DqText variant="body-strong">
                        {formatMessage(BundleMessages.bundleInstructionsSupportTitle)} -{' '}
                      </DqText>
                      <DqText variant="body">{formatMessage(BundleMessages.bundleInstructionsSupportLine1)}</DqText>
                    </IonCol>
                    <IonCol size="12">
                      <IonButton href="https://www.stoneagetools.com/support" target="_blank">
                        {formatMessage(GenericMessages.contactSupportLabel)}
                      </IonButton>
                    </IonCol>
                  </IonRow>
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

interface BundleInstructionsHeaderProps {
  title: string;
  sectionNumber?: string;
}

const BundleInstructionsHeader: FC<BundleInstructionsHeaderProps> = ({ title, sectionNumber }) => {
  return (
    <IonItem color="transparent" lines="none">
      {sectionNumber && (
        <IonChip disabled={true} slot="start" className="number-badge" style={{ marginRight: '8px' }}>
          {/*<IonChip disabled={true} slot="start" className="number-badge">*/}
          {/* Inline style to force alignment of text and color on section number. */}
          <DqText style={{ marginRight: '6px', color: 'black', fontSize: 20 }}>{sectionNumber}</DqText>
        </IonChip>
      )}
      <IonLabel>
        <IonRow>
          <IonCol>
            <DqText variant="body-strong">{title}</DqText>
          </IonCol>
        </IonRow>
      </IonLabel>
    </IonItem>
  );
};
